import { mountRaceList } from './utils/mount-race-list.js';
import { LA_CITY_URL } from './constants.js';
import { SHARED_RACES } from './shared-races.js';

// City races in L.A. County (L.A. Vote): the 12 City of L.A. races first, in
// SHARED_RACES order, then every other city by title, with a dropdown by city.
// AP also covers the City of L.A. races; scripts/shared-races.js picks which
// feed each one comes from.

// first parameter here needs to match what's in the multipleRaces js file
mountRaceList('la-county-city-races', LA_CITY_URL, {
  // filter options: FilterSpec in stores.js
  filter: [
    // filter 1: the City of L.A. races, listed by their L.A. Vote ids
    { ids: SHARED_RACES.map((race) => race.lavote) },
    // filter 2: every other city (excludeIds so the L.A. races can't show twice)
    {
      tagsAny: ['cities'],
      excludeIds: SHARED_RACES.map((race) => race.lavote),
      sort: 'title',
    },
  ],
  component: 'result', // to show 2 col table
  // to use a certain tag as a dropdown. If you don't need a dropdown, just not add this dropdown parameter
  dropdown: 'cities',
  // Shows AP's race in place of L.A. Vote's for the ones set to 'ap'
  sharedRaces: SHARED_RACES,
}).catch(console.error);
